import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=7c43ab28&scoped=true"
import script from "./paper.vue?vue&type=script&lang=js"
export * from "./paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43ab28",
  null
  
)

export default component.exports